import './commitment-avatar-tooltip.scss';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@sola/ark-core/molecules/tooltip/tooltip.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';

export const CommitmentAvatarTooltip = ({
  translation,
  usePortal = true,
}: {
  translation: string;
  usePortal?: boolean;
}) => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <button
          type="button"
          className="CommitmentAvatarTooltip flex items-center justify-center"
          aria-label="Additional information"
        >
          <ArkIcon iconName="info-circle" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        className="label-md lg:label-lg"
        align="center"
        alignOffset={-12}
        usePortal={usePortal}
      >
        {translation}
      </TooltipContent>
    </Tooltip>
  );
};
